import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedUrlRoutes } from '@formbird/shared';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class PhoneService {

  constructor(
    private httpClient: HttpClient
  ) { }

  sendSMS(phoneNum, message, callback) {
  const url = SharedUrlRoutes.serverRoutes.sendPhoneSMS;
  const params = {
    targetNum: phoneNum,
    message: message
  };

  this.httpClient.post(url, params).subscribe(
    (result) => {
      callback(null, result);
    },
    (err) => {
      callback(err);
    });
}

validateNumber(phoneNum, callback) {
  const url = SharedUrlRoutes.serverRoutes.validatePhoneNumber;
  const params = {
    phoneNum: phoneNum
  };
  this.httpClient.post(url, params).subscribe(
    (result) => {
      callback(null, result);
    },
    (err) => {
      callback(err);
    });
}

getServiceName(callback) {
  const url = SharedUrlRoutes.serverRoutes.phoneServiceName;
  const params = {};
  this.httpClient.post(url, params).subscribe(
    (result: any) => {
      callback(null, result.serviceName);
    },
    (err) => {
      logger.warn('Could not load service name for phone service.');
      callback(err);
    });
}
}
